import { render, staticRenderFns } from "./payment-chat.vue?vue&type=template&id=0d96059c&scoped=true"
import script from "./payment-chat.vue?vue&type=script&lang=js"
export * from "./payment-chat.vue?vue&type=script&lang=js"
import style0 from "./payment-chat.vue?vue&type=style&index=0&id=0d96059c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d96059c",
  null
  
)

export default component.exports